module.exports = __webpack_public_path__ + "img/auSaturdayLotto_icon.fffef329.png";